import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "full-width"
}
const _hoisted_2 = { class: "full-width" }
const _hoisted_3 = {
  key: 0,
  class: "scroll-x container-full-bleed"
}
const _hoisted_4 = { class: "c-container q-px-sm" }

import {computed, ref, watch} from 'vue';
import {Advert} from 'src/models/advert';
import Adverts from 'src/api/adverts';
import AdvertCard from 'src/apps/adverts/components/AdvertCard.vue';
import {useQuasar} from 'quasar';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvertRecommendation',
  props: {
  advertUuid: {
    type: String,
    required: true
  },
  target: {
    default: undefined,
    type: String
  }
},
  setup(__props) {

const adverts = ref<Array<Advert>>()
const loading = ref(false)
const $q = useQuasar()

const props = __props

const getRecommendations = () => {
  loading.value = true
  Adverts.fetchAdvertRecommendations(props.advertUuid).then(resp => {
    adverts.value = resp.data
  }).catch(err => {
    console.error(err)
  }).finally(() => {
    loading.value = false
  })
}

const cmpAdverts = computed(() => {
  if ($q.screen.gt.xs && $q.screen.lt.lg) {
    return adverts.value?.slice(0, 6)
  }
  return adverts.value
})

watch(
  () => props.advertUuid,
  () => {
    getRecommendations()
  },
  {immediate: true},
)


return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (cmpAdverts.value?.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_q_separator, { class: "q-my-md" }),
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "q-mb-md" }, " Das könnte dich auch interessieren", -1)),
          (__props.advertUuid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cmpAdverts.value, (advert) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: advert.uuid,
                      class: "c-card"
                    }, [
                      _createVNode(AdvertCard, {
                        data: advert,
                        target: __props.target,
                        "hide-slider": ""
                      }, null, 8, ["data", "target"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})